'use client';

import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import breakpoints from '@/lib/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

import { SectionsNavProps } from '@/models/Applications';

import ApplicationsDesktop from './ApplicationsDesktop';
import ApplicationsMobile from './ApplicationsMobile';

export default function ApplicationsNav(props: SectionsNavProps) {
  const { sectionnavigation } = props;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.md})`);
  const [desktop, setDesktop]: [
    boolean | undefined,
    Dispatch<SetStateAction<boolean | undefined>>,
  ] = useState();

  useEffect(() => {
    setDesktop(isDesktop);
  }, [isDesktop]);

  return desktop ? (
    <ApplicationsDesktop sectionnavigation={sectionnavigation} />
  ) : (
    <ApplicationsMobile sectionnavigation={sectionnavigation} />
  );
}
